<template>
  <div id="form" class="modal with-header white" ref="modal">
    <div class="header-wrapper">
      <div class="modal-header">
        <div class="title">
          Add New Transcript Request
        </div>
        <ul class="right">
          <li>
            <a class="">
              <i class="material-icons grey-text text-darken-3">minimize</i>
            </a>
          </li>
          <li>
            <a @click="$_toggleFullScreen()">
              <i v-if="!fullScreen" class="material-icons grey-text text-darken-3">
                fullscreen
              </i>
              <i v-else class="material-icons grey-text text-darken-3">
                fullscreen_exit
              </i>              
            </a>
          </li>
          <li>
            <a class="goBack" @click="$_goBack()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade-in">
   
   <div class="modal-content grey lighten-4" v-if="ready">
    <div class="form-fields">
      <div 
      :class="field.layout"
      v-for="(field, index) in fields" v-bind:key="index">
        <field-types

          @uploads="$_filesToUpload($event)"
          @update="$_fieldsData($event)"
          :data-option="field"
        >
        </field-types>
      </div>
    </div>
     <div>
     </div>
   </div>
    </transition>
   <div class="loader-container" v-if="!ready">
        <div 
        class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
   </div>
    <div class="custom-footer">
      <div class="col left">
      <p style="margin:0px;">
        <label>
          <input v-model="notify"  type="checkbox" />
          <span>Send Notification</span>
        </label>
      </p>
      </div>
      <button
        :disabled="sending || !validateForm"
        @click="$_saveCheck()"
        class="btn z-depth-0 right">
        Save Request
      </button>
      <button class="btn btn-flat waves-effect transparent right" @click="$_goBack()">
        Cancel
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import formService from '@/services/formService'
import core from '@/functions'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
import recordFields from '@/components/transcripts/transcripts-incoming'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'
export default {
  name:'formView',
  components:{
    fieldTypes,
  },
  data(){
    let vm = this
    return {
     // fields:recordFields.fields,
      curr_index:0,
      notify:false,
      post: new Object,
      sending:false,
      fullScreen:false,
      ready:false,
      popFields: {},
      uploads:{
        data:new Array,
        ready:false,
        added:new Array, 
      },
      modal:{
        options:{
          onOpenStart:()=>{
              vm.ready = true 
          },
          onOpenEnd:()=>{
            core.updateFields()
          },
          dismissible:false
        },
        instance:null,
      }
    }
  },
  watch:{
    $route:function(nV){
      nV 
      ? this.modal.instance.close()
      : false
    },
  },
  created () {
    if (this.$route.name === 'view_entry'){
      this.$_fetchTs()
    }
  },
  mounted(){   
    this.$_vModal()
    this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)         
  },
  beforeDestroy(){
    try{
      this.modal.instance.close()
      this.modal.instance !== null 
      ? this.modal.instance.destroy()
      : false
    }catch(e){
      //console.log(e)
    }
  },
  computed:{
    ...mapState({
      users:state=> state.record.users,
      records:state => state.record.records,

    }),
    fields:{
      get(){
        return recordFields.generate()
      }
    },
    validateForm:{
      get(){
        return true //this.post.to !== '' & this.post.to !== undefined ? true: false 
      }
    }
  },
  methods:{
    $_fetchTs() {
      contentService.getTranscript(this.$route.params.id) 
      .then(res => { 
      this.popFields =  recordFields.populate(res.data.acf)
      })
    },
    $_vModal(){
      this.modal.instance = core.initModal(this.$refs.modal, this.modal.options)
      setTimeout(() => {
        this.modal.instance.open()
      }, 300);
    },
    $_filesToUpload($event){
     this.uploads.data.length < 0
     ? this.uploads.data = $event.data
     : this.uploads.data = [...this.uploads.data, ...$event.data]
    },
    $_processFiles(){
 
      let promises = this.uploads.data.map(item => contentService.uploadFile(item.data))
      const count =  {
          promises:promises.length,
          sucess:0,
          files:new Array,
      }
      Promise.all(promises)
        .then(res=>{         
         count.sucess = count.sucess + 1
         count.files.push({file:res[count.sucess - 1].data.id})
         this.uploads.added.push({file:res[count.sucess - 1].data.id})
         if(count.promises === count.sucess) {
          
           this.uploads.ready = true
           setTimeout(() => {
             this.$_saveRecord()
           }, 100);
            window.console.log('uploadDone')          
          }        
        })
    },
    $_fieldsData($event){
      let log_structure = (v) => {
        return {
          id:v.id,
          date: new Date,
          message: v.notes
        }
      }
      const record =  this.fields.find(item => item.name === $event.name)
      if($event.name === 'logs') {
          record.values = $event.data.map(item => log_structure(item))
      } else {
        if(record){
          if(record.name === 'from' || record === 'to') record.values = $event.data
          else record.values = $event.data
        } 
      }
     this.post = this.$_postStructure()
    },
    $_toggleFullScreen(){ 
        this.$refs.modal.classList.toggle('fullScreen')  
        let test = () => {
           return  this.$refs.modal.classList.contains('fullScreen')
        } 
       if(test()) {
          this.fullScreen = true
       }
      if(!test()) {
        this.fullScreen = false        
      }
    },
    $_goBack(){
      this.$router.go(-1)
    },
    $_editValues($event){
      let payload = {
        action:'update_field_values',
        uid:$event.field,
        data:$event.values
      }
      this.$store.commit('ADD_FIELDS_DATA', payload)
    },
    $_sendNotificaiton(data){
      let fromUser = this.users.find(user => user.id === parseInt(data.acf.from))
      let toUser = this.users.find(user => user.id === parseInt(data.acf.to))
      let payload = {
        from:fromUser.acf.first_name +' '+ fromUser.acf.last_name,
        to:toUser.acf.first_name +' '+toUser.acf.last_name,
        record:data.acf.id,
        routeuser:toUser.acf.email,
        message:`New record created by user see below for details`,
        url:`https://docs.eccourts.org/records/record/view/${data.id}`,
      }
      formService.newRecord(payload)
      .then(res =>{ 
        window.console.log(res)
      })
    },
    $_postStructure(){
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : ''
        }
        return {
          name: mapValue('name'),
          email:mapValue('email'),
          case_number: mapValue('case_number'),
          requesting_party: mapValue('requesting_party'),
          transcriptionist: mapValue('transcriptionist'),
          case_name: mapValue('case_name'),
          practitioners: mapValue('practitioners'),
          heard:mapValue('heard'),
          contact:mapValue('contact'),
          judges: mapValue('judges') ? mapValue('judges').map(e => {return {judge: e.notes}}) : '',
          appearances: mapValue('appearances'),
          logs: mapValue('logs'),
          status: mapValue('status').prop,
          request_form: mapValue('request_form'),
          comments: mapValue('comments'),
          turn_around_time: mapValue('turn_around_time'),
          hearing_dates: mapValue('hearing_dates') ? mapValue('hearing_dates').map(e => {return {date: e.notes}}) : '',
          file_links: mapValue('file_links') && mapValue('file_links').length ? mapValue('file_links').map(e => {return {url: e.notes}}) : '',
          other_attachments: this.content.acf.other_attachments ? this.content.acf.other_attachments.map(x => x.ID) : []
        }
    },
    $_saveCheck(){
      if ( this.uploads.data.length > 0){
        this.$_processFiles()
      } else {
        setTimeout(() => {
          this.$_saveRecord()
        }, 500);
      }
    },
/*     $_saveRecordo () {
   const post = this.post
      const structure = {
        title:post.case_number,
        status:'publish',
        fields:{
          ...this.post,
          other_attachments: this.uploads.added.map(item=> {return {id:item.file}})
        }
      }
     
    }, */
    $_saveRecord (){
      const structure = {
        title:this.fields.find(item => item.name === 'name' ).values,
        status:'publish',
        fields:{
          ...this.post,
        }
      }
     contentService.saveTranscript(structure)
      .then(res=>{
        core.toastMessage('Item Added Successfully')
        this.notify 
        ? this.$_sendNotificaiton(res.data)
        : false

        this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)
        this.post = new Object
       
        setTimeout(() => {
          this.ready = true
          this.sending = false
        }, 600);  
      })   
    },
  }
}
</script>
<style lang="scss" scoped>
#form{
  &.modal {
     min-height: 85% !important;
    &.fullScreen {
      top: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
    }
  }
  @media screen and (max-width: 680px){
    width:100%;
    top:0% !important;
    height: 100%;
    min-height: 100%;
  }
  &.modal.with-header {
    padding: 0;
    border-radius:6px;
    height: 70%;
  .header-wrapper {
    height:56px;
    position: relative;
    .modal-header {
      position: absolute;
      width:100%;
      padding:20px;
      top: 0;
      line-height:56px;
      height:100%;
      padding:0px 20px;
      border-bottom: .4px solid rgba(0,0,0,0.4);
      .title {
        font-size: 22px;
        display: inline;
      }
      ul {
        display: inline-flex;
        margin:0px;
         li {

           a {
             cursor: pointer;
             margin:0 8px;
              i {
                line-height: 56px;
              }
           }
         }
      }
    }
  }
  .modal-content {
    position: absolute;
    height: calc(100% - 122px);
    max-height: 100%;
    width: 100%;
    top:56px;
    padding:20px;
    overflow-y: auto;
  }
 }
  .custom-footer {
    position: fixed;
    bottom: 0;
    left:0;
    padding: 15px;
    width: 100%;
    background: white;
  }

.loader-container {
  top:50%;
  left:50%;
  width:64px;
  height: 64px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9;
}

}
</style>
<style lang="scss">

#form {
    .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      
      color:black;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default),
    input[type=email]:not(.browser-default),
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
      background:white;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
      background:white;
    }
}
</style>